import { render } from "./S208881.vue?vue&type=template&id=5b97d69c&scoped=true"
const script = {}

import "./S208881.vue?vue&type=style&index=0&id=5b97d69c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5b97d69c"

export default script